import React, { useState, useEffect } from "react";
import {
  BaseButtons,
  DropDownWithDisplay,
  LoadingPopUp,
  TextInputField,
  TextInputFieldArea,
} from "../../../../../common-components";
import { colors } from "../../../../../../themes/Colors";
import ImageUploadAWS from "../../../../../user/components/image-upload/ImageUploadAWS";
import useWindowDimensions from "../../../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import { CommentCard, RequestCard, TimelineCard } from "./components";

const ManageTaskPopUp = ({
  activeView,
  setActiveView,
  SubmitHandler,
  setToastPop,
  setMessage,
  loading,
  setLoading,
  auth,
  setRefresh,
  refresh,
  setPopUpTitle,
  selectedTask,
  setSelectedTask,
}) => {
  const [file, setFile] = useState(null);
  const { width, height } = useWindowDimensions();
  const [opened, setOpened] = useState(null);
  const [tabDisplay, setTabDisplay] = useState("time line");
  const [customerData, setCustomerData] = useState(null);
  const handleFileChange = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setFile(file);
  };
  const [taskComments, setTaskComments] = useState([]);
  const [taskRequests, setTaskRequests] = useState([]);
  const [taskTimeline, setTasktimeline] = useState([]);

  const updateTask = async () => {
    setLoading(true);

    /*try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/task/updateTask",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            vehicleIdentifier: vehicleIdentifier,
            taskReference: taskReference,
            incidentDate: incidentDate,
            taskDescription: taskDescription,
            loggedByUser: auth.userId,
            documentUuid: file,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setToastPop(true);
        setMessage(respnseData.success);
        setPopUpTitle("SUCCESS");
        setActiveView("");
        setRefresh(refresh ? false : true);
        setLoading(false);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage(respnseData.message);
        setLoading(false);
      }
    } catch (err) {
      setPopUpTitle("FAILURE");
      setToastPop(true);
      setMessage(
        "No network try again after connecting, if this persists please contact support"
      );
      setLoading(false);
    }*/
  };
  const getTaskUserInfo = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/getAgencyCustomerInfo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: selectedTask.requestedByUserId,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);
        setCustomerData(respnseData.customers);
        // setToastPop(true);
        // setPopUpTitle("SUCCESS");
        // setMessage("Log-in successful");

        // setToastPop(true);
      } else {
        setLoading(false);
      }
      //  else {
      //   setLoading(false);
      //   setPopUpTitle("FAILED");
      //   setMessage("Unable to find customers, " + " " + respnseData.message);
      //   setToastPop(true);
      // }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      // setMessage(
      //   "Unable to login into account, please wait 5 mins then try again or contact support" +
      //     " " +
      //     err
      // );
      // setToastPop(true);
    }
  };

  useEffect(() => {
    if (selectedTask) {
      setTaskComments(selectedTask.taskComments);
      setTaskRequests(selectedTask.taskRequests);
      setTasktimeline(selectedTask.taskTimeline);
      getTaskUserInfo();
    } else {
      console.log("No task :( ");
      setTaskComments([]);
      setTaskRequests([]);
      setTasktimeline([]);
    }
  }, [selectedTask]);
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        backgroundColor: colors.white,
        height: selectedTask ? "100%" : 0,
        width: "100%",
        overflow: "hidden",
        transition: "all 0.28s",
        opacity: selectedTask ? 1 : 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          flex: 1,
          width: "100%",
          display: "flex",
          justifyContent: "left",
          alignItems: "center",
          position: "relative",
        }}
      >
        {/* <div style={{ minHeight: 180 }} /> */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "35%",
            height: "95%",
            position: "relative",
            backgroundColor: colors.white,
            marginTop: 80,
          }}
        >
          <div
            style={{
              position: "relative",
              paddingTop: 20,
              fontSize: 18,
              fontWeight: "bold",
              color: colors.secondaryDarkBlue,
              // marginTop: 60,
              width: "90%",
            }}
          >
            TASK DETAILS
          </div>
          <div style={{ width: "80%" }}>
            <TextInputField
              labelTitle={"TITLE"}
              mini={true}
              width={"100%"}
              size={"100%"}
              value={selectedTask ? selectedTask.taskTitle : "loading"}
              readOnly={true}
            />
            <TextInputField
              labelTitle={"TYPE"}
              mini={true}
              width={"100%"}
              size={"100%"}
              value={selectedTask ? selectedTask.taskType : "loading"}
              readOnly={true}
            />
            <TextInputField
              labelTitle={"STATUS"}
              mini={true}
              width={"100%"}
              size={"100%"}
              value={selectedTask ? selectedTask.taskStatus : "loading"}
              readOnly={true}
            />
            <TextInputField
              labelTitle={"AGENCY NAME"}
              mini={true}
              width={"100%"}
              size={"100%"}
              value={selectedTask ? selectedTask.agencyName : "loading"}
              readOnly={true}
            />

            <TextInputFieldArea
              labelTitle={"DETAILS"}
              mini={true}
              width={"100%"}
              size={"100%"}
              value={selectedTask ? selectedTask.taskDetails : "loading"}
              readOnly={true}
              height={100}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            //justifyContent: "center",
            alignItems: "center",
            width: "65%",
            height: "95%",
            position: "relative",
            marginTop: 70,
          }}
        >
          <div
            style={{
              position: "relative",
              paddingTop: 20,
              fontSize: 18,
              fontWeight: "bold",
              color: colors.secondaryDarkBlue,
              width: "100%",
              display: "flex",
              alignItems: "center",
              paddingBottom: 20,
            }}
          >
            <div style={{}}>TASK {tabDisplay.toUpperCase()}</div>
            <div style={{ flex: 1 }} />
            <div style={{ marginRight: 10, display: "flex" }}>
              <BaseButtons
                label={"CUSTOMER"}
                borderRadius={4}
                backgroundColor={
                  tabDisplay === "customer"
                    ? colors.greenLight
                    : colors.greenDark
                }
                onClick={() => setTabDisplay("customer")}
              />
              <div style={{ minWidth: 10 }} />
              <BaseButtons
                label={"VEHICLE"}
                borderRadius={4}
                backgroundColor={
                  tabDisplay === "vehicle"
                    ? colors.greenLight
                    : colors.greenDark
                }
                onClick={() => setTabDisplay("vehicle")}
              />
              <div style={{ minWidth: 10 }} />
              <BaseButtons
                label={"COMMENTS"}
                borderRadius={4}
                backgroundColor={
                  tabDisplay === "comments"
                    ? colors.greenLight
                    : colors.greenDark
                }
                onClick={() => setTabDisplay("comments")}
              />
              <div style={{ minWidth: 10 }} />
              <BaseButtons
                label={"REQUESTS"}
                borderRadius={4}
                backgroundColor={
                  tabDisplay === "requests"
                    ? colors.greenLight
                    : colors.greenDark
                }
                onClick={() => setTabDisplay("requests")}
              />
              <div style={{ minWidth: 10 }} />
              <BaseButtons
                label={"TIME LINE"}
                borderRadius={4}
                backgroundColor={
                  tabDisplay === "time line"
                    ? colors.greenLight
                    : colors.greenDark
                }
                onClick={() => setTabDisplay("time line")}
              />
            </div>
          </div>
          <div
            style={{
              width: "99%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              fontWeight: "bold",
              fontSize: 15,

              height: height - 200,
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            {/* I CANNOT GET THESE TO DISPLAY IN A TABLE LIKE FORMAT, I MIGHT LOSE THE PLOT */}
            {tabDisplay === "requests" && taskRequests
              ? taskRequests.map((req, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        width: "95%",
                        display: "flex",
                        flexDirection: "column",
                        // minHeight: 100,
                        minWidth: 200,
                        borderRadius: 8,
                        marginTop: 20,
                        padding: 10,
                        backgroundColor: colors.white,
                        WebkitBoxShadow: "0px 0px 7px 2px #00000030",
                        position: "relative",
                      }}
                    >
                      <RequestCard req={req} />
                    </div>
                  );
                })
              : null}
            {tabDisplay === "comments" && taskRequests
              ? taskComments.map((req, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        width: "95%",
                        display: "flex",
                        flexDirection: "column",
                        // minHeight: 100,
                        minWidth: 200,
                        borderRadius: 8,
                        marginTop: 20,
                        padding: 10,
                        backgroundColor: colors.white,
                        WebkitBoxShadow: "0px 0px 7px 2px #00000030",
                        position: "relative",
                      }}
                    >
                      <CommentCard req={req} />
                    </div>
                  );
                })
              : null}
            {tabDisplay === "time line" && taskRequests
              ? taskTimeline.map((req, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        width: "95%",
                        display: "flex",
                        flexDirection: "column",
                        // minHeight: 100,
                        minWidth: 200,
                        borderRadius: 8,
                        marginTop: 20,
                        padding: 10,
                        backgroundColor: colors.white,
                        WebkitBoxShadow: "0px 0px 7px 2px #00000030",
                        position: "relative",
                      }}
                    >
                      <TimelineCard req={req} />
                    </div>
                  );
                })
              : null}
            {tabDisplay === "vehicle" ? (
              <div style={{ position: "relative", width: "100%" }}>
                {/* // control number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.b,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    CONTROL NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {selectedTask ? selectedTask.vehicleId.controlNumber : null}
                  </div>
                </div>
                {/* // document number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    DOCUMENT CODE:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {selectedTask ? selectedTask.vehicleId.docCode : null}
                  </div>
                </div>
                {/* // issue number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    ISSUE NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {selectedTask ? selectedTask.vehicleId.issueNumber : null}
                  </div>
                </div>
                {/* // date of issue */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    DATE OF ISSUE:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {selectedTask ? selectedTask.vehicleId.dateOfIssue : null}
                  </div>
                </div>
                {/* // indentification number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    IDENTIFICATION NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {selectedTask
                      ? selectedTask.vehicleId.indentificationNumber
                      : null}
                  </div>
                </div>
                {/* // register number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    REGISTER NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {selectedTask
                      ? selectedTask.vehicleId.registerNumber
                      : null}
                  </div>
                </div>
                {/* // vehicle identifiction number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    VEHICLE IDENTIFICATION NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {selectedTask
                      ? selectedTask.vehicleId.vehicleIndentificationNumber
                      : null}
                  </div>
                </div>
                {/* // engine number  */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    ENGINE NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {selectedTask ? selectedTask.vehicleId.engineNUmber : null}
                  </div>
                </div>
                {/* // Make  */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    MAKE:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {selectedTask ? selectedTask.vehicleId.make : null}
                  </div>
                </div>
                {/* // Make  */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    SERIES:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {selectedTask ? selectedTask.vehicleId.series : null}
                  </div>
                </div>
                {/* //transaction number */}
                <div
                  style={{
                    position: "absolute",
                    top: -40,
                    right: 20,
                    textAlign: "right",
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    TRANSACTION NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {selectedTask ? selectedTask.vehicleId.transactionNr : null}
                  </div>
                </div>
                <div style={{ minHeight: 20 }} />
              </div>
            ) : null}

            {tabDisplay === "customer" ? (
              <div style={{ width: "100%", position: "relative" }}>
                {/* // TITLE */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    TITLE:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {customerData ? customerData.title : null}
                  </div>
                </div>
                {/* // name */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    NAME:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {customerData
                      ? customerData.firstName + " " + customerData.lastName
                      : null}
                  </div>
                </div>

                {/* Cell number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    Cell Number:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {customerData ? customerData.cellNumber : null}
                  </div>
                </div>

                {/* Email */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    Email:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {customerData ? customerData.email : null}
                  </div>
                </div>

                {/* id number */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    ID NUMBER:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {customerData ? customerData.idDoc : null}
                  </div>
                </div>

                {/* Address */}
                <div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 20,
                      marginLeft: 20,
                      opacity: 0.8,
                    }}
                  >
                    ADDRESS:
                  </div>
                  <div
                    style={{
                      fontSize: 18,
                      // fontWeight: "bold",
                      // color: colors.white,
                      marginTop: 5,
                      marginLeft: 20,
                    }}
                  >
                    {customerData ? customerData.address : null}
                  </div>
                </div>
              </div>
            ) : null}
            <div style={{ minHeight: 20 }} />
          </div>
        </div>
        {/* back and close buttons */}
        <div style={{ position: "absolute", top: 10, left: 10, zIndex: 301 }}>
          <BaseButtons
            label={"CLOSE"}
            width={100}
            backgroundColor={colors.secondaryOrange}
            onClick={() => {
              setSelectedTask(null);
            }}
            borderRadius={10}
          />
        </div>
        <div
          style={{
            position: "absolute",
            top: 20,
            fontSize: 18,
            fontWeight: "bold",
            color: colors.secondaryDarkBlue,
            left: 140,
          }}
        >
          MANAGE TASK
        </div>
        {/* next and complete buttons */}
        {/* <div style={{ position: "absolute", top: 10, right: 10 }}>
          <BaseButtons
            label={"UPDATE"}
            width={100}
            backgroundColor={colors.greenLight}
            borderRadius={10}
            // onClick={() => addTask()}
          />
        </div> */}
      </div>
    </div>
  );
};

export default ManageTaskPopUp;
